module.exports = __webpack_public_path__ + "img/bookshelf20.5c95286c.jpg";